import makeStyles from '@material-ui/core/styles/makeStyles'
import {Text} from '../../1elements'
import AddNewChip from '../../2compounds/AddNewChip'
import TrainingRecordFieldSet from '../../2compounds/TrainingRecordFieldSet'

const RecordsForm = ({addRecord, deleteRecord, value, updateRecordData, showError, disabled}) => {
    const classes = useStyles()

    return(
        <div className={classes.root}>

            <Text type={'fieldLabel'}>Training Records</Text>

            {value.map((record, index)=>{
                const {recordType, recordName, recordLink, expiryDate, effectiveDate} = value[index]
                return(
                    <TrainingRecordFieldSet index={index} showError={showError} disabled={disabled}
                                            recordType={recordType} recordName={recordName} recordLink={recordLink}
                                            effectiveDate={effectiveDate} expiryDate={expiryDate}
                                            deleteRecord={deleteRecord} updateRecordData={updateRecordData} />
                )
            })}

            <AddNewChip onClick={addRecord} disabled={disabled} />
        </div>
    )
}

const useStyles = makeStyles({
    root: {
    },
    formRow: {
        display: 'flex',
        margin: '0 0 40px'
    },
    formRowFields: {
        display: 'grid',
        gap: '10px 20px',
        gridTemplateColumns: '1fr 1fr',
        marginLeft: '5px',
        '&>div': {
            flexGrow: 2
        }
    },
    recordsTypeSelect: {
        flexGrow: 2,
        margin: '0 10px'
    },
    formRowInside: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    formRowRow: {
        display: 'flex'
    }
})

export default RecordsForm